import React, { FC, useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';

export const PasswordInput: FC<TextFieldProps> = ({
  name = '',
  onChange,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { watch, register, setValue } = useFormContext();

  const passwordValue = watch(name);

  const handleClickShowPassword = () => {
    setValue(name, passwordValue);
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      {...props}
      {...register(name, { onChange })}
      type={showPassword ? 'text' : 'password'}
      value={passwordValue || ''} // Ensure empty string if no value
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
